import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { TextFieldComponent } from '../../../fields/standard/text-field/text-field.component';
import { AppModule } from '../../../../modules/app.module';
import { ZorroModule } from '../../../../modules/zorro.module';
import { ThirdPartyModule } from '../../../../modules/third-party.module';
import { AngularModule } from '../../../../modules/angular.module';
import { FormBoxComponent } from '../../../ui/forms/form-box/form-box.component';
import { FormLabelComponent } from '../../../ui/forms/form-label/form-label.component';
import { FormSubmitButtonComponent } from '../../../ui/forms/form-submit-button/form-submit-button.component';
import { FormLinkComponent } from '../../../ui/forms/form-link/form-link.component';
import { HomeState } from '@mira-avant/mtlibs';

@Component({
	selector: 'app-forgot-password-form',
	standalone: true,
	imports: [
		AppModule,
		ZorroModule,
		ThirdPartyModule,
		AngularModule,
		TextFieldComponent,
		FormBoxComponent,
		FormLabelComponent,
		FormSubmitButtonComponent,
		FormLinkComponent,
	],
	templateUrl: './forgot-password-form.component.html',
	styleUrl: './forgot-password-form.component.scss',
})
export class ForgotPasswordFormComponent {
	@Output('onSubmit') public onSubmitEmitter: EventEmitter<any> = new EventEmitter<any>();
	@Output('onSwitchState') public onSwitchStateEmitter: EventEmitter<HomeState> = new EventEmitter<HomeState>();
	@Input('loading') public loading: boolean = false;
	@Input() public signupLinkResend: boolean = false;

	public form: FormGroup = this.fb.group({
		email: ['', TextFieldComponent.validators],
	});

	constructor(private fb: FormBuilder) {}

	public onSubmit() {
		this.onSubmitEmitter.emit(this.form.value);
	}

	public clear(): void {
		this.form.reset();
	}

	public onBack() {
		this.onSwitchStateEmitter.emit(HomeState.LOGIN);
	}
}
